import React from 'react';
import { FormGroup, FieldRow } from '@ajat/design-system/FormGroup';
import Input from '@ajat/design-system/Input';
import { ComponentPage, DemoCard } from '../shared';

export const meta = {
  title: 'Form Group',
  group: 'Forms',
  importPath: '@ajat/design-system/FormGroup',
  description:
    'Structure for forms. FormGroup is a titled fieldset (an H5 legend with an optional note); FieldRow puts fields side by side on a named split — first + last name on 1:1, postcode + city on 2:3 — on phones too.',
  propSets: [
    {
      title: 'FormGroup',
      component: FormGroup,
      componentName: 'FormGroup',
      rows: [
        ['legend', 'node', '—', 'Group title (H5)'],
        ['note', 'node', '—', 'A line under the legend that reads with it'],
        ['className', 'string', "''", 'Additional CSS class'],
        ['children', 'node', '—', 'The fields'],
      ],
    },
    {
      title: 'FieldRow',
      component: FieldRow,
      componentName: 'FieldRow',
      rows: [
        ['columns', "'1:1' | '2:3' | '3:2' | '1:2' | '2:1'", "'1:1'", 'Column split'],
        ['className', 'string', "''", 'Additional CSS class'],
        ['children', 'node', '—', 'The fields'],
      ],
    },
  ],
  usage: [
    {
      title: 'Profile form',
      code: `import { FormGroup, FieldRow } from '@ajat/design-system/FormGroup';

<FormGroup legend="Om dig">
  <FieldRow>
    <Input label="Förnamn" reserveMessageSpace />
    <Input label="Efternamn" reserveMessageSpace />
  </FieldRow>
</FormGroup>
<FormGroup legend="Leveransadress" note="Alla fält eller inget – vi levererar inom Sverige.">
  <Input label="Gatuadress" reserveMessageSpace />
  <FieldRow columns="2:3">
    <Input label="Postnummer" reserveMessageSpace />
    <Input label="Ort" reserveMessageSpace />
  </FieldRow>
</FormGroup>`,
    },
  ],
};

export default function FormGroupPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Groups and rows">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-ui-medium-l)', maxWidth: 480 }}>
          <FormGroup legend="Om dig">
            <FieldRow>
              <Input label="Förnamn" showIcon={false} reserveMessageSpace />
              <Input label="Efternamn" showIcon={false} reserveMessageSpace />
            </FieldRow>
            <Input label="Mobil" type="tel" showIcon={false} helperText="För leveransaviseringar" reserveMessageSpace />
          </FormGroup>
          <FormGroup legend="Leveransadress" note="Alla fält eller inget – vi levererar inom Sverige.">
            <Input label="Gatuadress" showIcon={false} reserveMessageSpace />
            <FieldRow columns="2:3">
              <Input label="Postnummer" showIcon={false} reserveMessageSpace />
              <Input label="Ort" showIcon={false} reserveMessageSpace />
            </FieldRow>
          </FormGroup>
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
